import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  location_data = {};

  constructor(private _http: HttpClient) {
    if (localStorage.getItem('currentUser') == null) {
      window.location.href = `${environment.SITE_URL}/logout`;
    }
  }

  getRequest(url, mode = null, extraHeader = null): Observable<any> {
    let httpOptions = {};
    if (extraHeader == 'content-type-json') {
      httpOptions = {headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    }
    else {
      httpOptions = { headers: new HttpHeaders({}) };
    }
    return this._http
      .get<any>(url, httpOptions)
      .pipe(
        map((resp) => {
          if (mode == 'getDrafted') {
            localStorage.removeItem('draftedToday');
            localStorage.setItem('draftedToday', JSON.stringify({
              expires: Date.now() + 60000,
              value: resp.leagues
            }));
            return resp;
          }
          else {
            return resp;
          }
        })
      );
  }

  postRequest(url, data, mode = null, extraHeader = null): Observable<any> {
    let httpOptions = {};
    if (extraHeader == 'content-type-json') {
      httpOptions = {headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    }
    else {
      httpOptions = { headers: new HttpHeaders({}) };
    }
    return this._http
      .post<any>(url, data, httpOptions)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError(this.handleErrorPost<any>('rejectRequest'))
      );
  }
  putRequest(url, data, mode = null, extraHeader = null): Observable<any> {
    let httpOptions = {};
    if (extraHeader == 'content-type-json') {
      httpOptions = {headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    }
    else {
      httpOptions = { headers: new HttpHeaders({}) };
    }
    return this._http
      .put<any>(url, data, httpOptions)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError(this.handleErrorPost<any>('rejectRequest'))
      );
  }

  hasUserLocation() {
    let subp = localStorage.getItem('subp');
    if (typeof (subp) === 'undefined' || !subp) {
      return false;
    }
    else {
      let subDecode = (atob(subp)).split('#');
      if(typeof subDecode[5]!='undefined'){
        let currentTime = Math.floor(new Date().getTime()/1000);
        let diff =  parseInt(subDecode[5]) - currentTime;
        let min = (diff <= 0) ? false : true;
        return min;
      } else {
        return false;
      }
    }
  }

  getUserLocation() {
    let locationData = { 'ip': '0', 'state': '0', 'country': '0', 'user_dob': '0000-00-00','postcode':'0','expiry':'0'};
    let subp = localStorage.getItem('subp');
    if (typeof (subp) !== 'undefined' && subp) {
      let subDecode = (atob(subp)).split('#');
      locationData = {
        'ip': subDecode[0],
        'state': subDecode[1],
        'country': subDecode[2],
        'user_dob': subDecode[3],
        'postcode': subDecode[4],
        'expiry': subDecode[5]
      };
    }
    return locationData;
  }

  modifyUserLocation(data) {
    let subp = localStorage.getItem('subp');
    if (typeof (subp) !== 'undefined' && subp) {
      let subDecode = (atob(subp)).split('#');
      let modifiedSubp = btoa(subDecode[0] + '#' + data['state'] + '#' + data['country'] + '#' + subDecode[3] + '#' + subDecode[4] + '#' + subDecode[5]);
      localStorage.removeItem('subp');
      localStorage.setItem('subp', modifiedSubp);
    }
    return;
  }

  setUserLocation(url, callback) {
    let subp = '';
    let locationData = { 'ip': '0', 'state': '0', 'country': '0', 'user_dob': '0000-00-00','postcode':'0','expiry':'0'};
    let httpOptions = { headers: new HttpHeaders({}) };
    let request = this._http
      .get<any>(url, httpOptions)
      .pipe(
        map((res) => {
          return res;
        })
      );

    request.subscribe(res => {
      if (typeof res !== 'undefined' && res['status'] == 'success') {
        let currentTime = Math.floor(new Date().getTime()/1000);
        let updatedTIme = currentTime + 2 * 60 * 60;
        locationData = {
          'ip': res['ip'],
          'state': res['state'],
          'country': res['country'],
          'user_dob': res['user_dob'],
          'postcode': res['postcode'],
          'expiry': updatedTIme.toString()
        };
        subp = btoa(res['ip'] + '#' + res['state'] + '#' + res['country'] + '#' + res['user_dob']+'#'+res['postcode']+'#'+updatedTIme.toString());
      }
      localStorage.removeItem('subp');
      localStorage.setItem('subp', subp);
      callback(locationData);
    });
  }
  
  uploadS3File(file, callback) {
    let response = {status : false};
    let randomString = (Math.random() + 1).toString(36).substring(2);
    let ext = (file.name).split('.').pop();
    let fileName = randomString + '.' + ext;
    const bucket = new S3(
      {
        accessKeyId: environment.S3_ACCESS_KEY,
        secretAccessKey: environment.S3_SECRET_KEY,
        region: environment.AWS_REGION
      }
    );
    const params = {
      Bucket: environment.AWS_BUCKET,
      Key: environment.AWS_BUCKET_DIRECTORY + fileName,
      Body: file,
      ACL: 'public-read',
      ContentType: file.type
    };
    
    bucket.upload(params, function (err, data) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
        callback(response);
      }
      
      response['status'] = true;
      response['fileName'] = fileName; 
      
      //console.log('Successfully uploaded file.', data);
      callback(response);
    });
  }

  private handleErrorPost<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(result); // log to console instead 
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}